import PropTypes from 'prop-types';
import React, {memo, useEffect, useState} from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from '../Modal';
import {toast} from 'react-toastify';
import {COMPLETE_COURSE_ENROLLMENT_TOAST_MESSAGES, getErrorUpdateToastPropsBy, getSuccesToastPropsBy} from '../../../service/toastService';

function AddConsultancyExperienceModal({id, experience, setExperience, setIsChecked}) {
    const [consultancyFirm, setConsultancyFirm] = useState('');
    const [otherConsultancyFirm, setOtherConsultancyFirm] = useState('');

    useEffect(() => {
        if (experience && experience.consultancyCompany) {
            setConsultancyFirm(experience.consultancyCompany);
        }
    }, [experience]);

    const handleConsultancyFirmChange = (e) => {
        const firm = e.target.value;
        setConsultancyFirm(firm);
    };

    const handleOtherConsultancyFirmChange = (e) => {
        const firm = e.target.value;
        setOtherConsultancyFirm(firm);
    }

    const handleAddConsultantExperience = async () => {
        try {
            if (consultancyFirm === '') {
                toast.error('Please provide the consultancy firm before proceeding', getErrorUpdateToastPropsBy(COMPLETE_COURSE_ENROLLMENT_TOAST_MESSAGES));
                return;
            }
            if (experience) {
                setExperience((prevExperience) => ({
                    ...prevExperience,
                    isConsultancy: true,
                    consultancyCompany: consultancyFirm === "other" ? otherConsultancyFirm : consultancyFirm,
                }));
            }

            setIsChecked(true);

            toast.success('You have successfully added your consultancy experience', getSuccesToastPropsBy(COMPLETE_COURSE_ENROLLMENT_TOAST_MESSAGES));
        } catch (error) {
            toast.error('Something went wrong! Try again later', getErrorUpdateToastPropsBy(COMPLETE_COURSE_ENROLLMENT_TOAST_MESSAGES));
        }
    };

    return (
        <Modal
            id={id}
            icon="pe-7s-portfolio"
            iconGradient="bg-green-blue-top"
            title="Select a Consultancy Firm"
            contentClass="modal-body-center-h"
            confirmText="SAVE"
            closeHandler={() => setConsultancyFirm('')}
            confirmHandler={handleAddConsultantExperience}>
            <div style={{width: '100%'}}>
                <div>
                    <label htmlFor="consultancyFirm">Consultancy Firm:</label>
                    <select className="form-control" id="consultancyFirm" value={consultancyFirm} onChange={handleConsultancyFirmChange}>
                        <option disabled value="">
                            Select a Consultancy Firm
                        </option>
                        <option value="TalentIT">TalentIT</option>
                        <option value="Team4Talent">Team4Talent</option>
                        <option value="Talent2Test">Talent2Test</option>
                        <option value="Talent4Insight">Talent4Insight</option>
                        <option value="other">Other (please specify)</option>
                    </select>
                    {consultancyFirm === 'other' && (
                        <div className="mt-3">
                            <input className="form-control" type="text" placeholder="Specify consultancy firm" value={otherConsultancyFirm}
                                   onChange={handleOtherConsultancyFirmChange}/>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
}

AddConsultancyExperienceModal.propTypes = {
    id: PropTypes.string.isRequired,
    experience: PropTypes.object.isRequired,
    setExperience: PropTypes.func.isRequired,
    setIsChecked: PropTypes.func.isRequired,
};

export default memo(AddConsultancyExperienceModal);
